export { InfoNote } from './InfoNote';
export type { InfoNoteProps } from './InfoNote.types';
